/**
 * Parse hexadecimal to rgb format
 * @param {string} hex #FFFFFF or #FFF
 * @param {boolean} functional if true returns using rgb()
 */
function hexToRGB(hex, functional) {
  var isValidHex = /^#([\da-f]{3}){1,2}$/i;
  var red = 0,
      green = 0,
      blue = 0;

  if (!isValidHex.test(hex)) {
    throw Error('The `hexadecimal` parameter is in an incorrect format');
  }

  if (hex.length === 4) {
    red = '0x' + hex[1] + hex[1];
    green = '0x' + hex[2] + hex[2];
    blue = '0x' + hex[3] + hex[3];
  }

  if (hex.length === 7) {
    red = '0x' + hex[1] + hex[2];
    green = '0x' + hex[3] + hex[4];
    blue = '0x' + hex[5] + hex[6];
  }

  if (functional) return "rgb(".concat(+red, ",").concat(+green, ",").concat(+blue, ")");
  return "".concat(+red, ",").concat(+green, ",").concat(+blue);
}

export default hexToRGB;